import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { type UpdateAdminPreferencesPayload } from '@avanta/shared/types/enterprises';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { MUTATION_KEYS } from 'constants/common';
import { EnterprisesService } from 'services/enterprises';
import { useUserStore } from 'stores/user';
import { type AdminEnterprise } from 'types/enterprises';

export const useUpdateAdminPreferences = (): UseMutationResult<
  AxiosResponse<AdminEnterprise>,
  AxiosError,
  UpdateAdminPreferencesPayload
> => {
  const queryClient = useQueryClient();
  const user = useUserStore(state => state.user as AdminEnterprise);

  return useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_ADMIN_PREFERENCES],
    mutationFn: async (payload: UpdateAdminPreferencesPayload) =>
      EnterprisesService.updateAdminPreferences(user.enterpriseId, user.id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_USER] });
    },
  });
};
